import { transformPxToRem as e } from "../../../utils/units.es.js";
import { c as r, d as o } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: t, definePartsStyle: i } = r([
  "base",
  "empty",
  "emptyIcon",
  "error",
  "errorIcon",
  "inner",
  "item"
]), n = o({
  position: "relative",
  overflow: "hidden",
  width: "100%",
  borderRadius: "md",
  backgroundColor: "beige.50",
  "&::before": {
    content: '""',
    display: "block",
    paddingTop: "100%"
  }
}), s = o({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  backgroundColor: "beige.50"
}), a = o({
  color: "primary.500"
}), l = o({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "beige.50"
}), c = o({
  color: "primary.500"
}), b = o({
  overflow: "hidden",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "1fr 1fr",
  borderRadius: "md",
  backgroundColor: "beige.50",
  transition: "all 0.25s ease-in-out",
  ":hover": {
    transform: "scale(1.1, 1.1)"
  }
}), d = o({
  position: "relative",
  "::before": {
    content: '""',
    display: "block",
    paddingTop: "100%"
  },
  "> img, > div": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center"
  }
}), m = i({
  base: n,
  empty: s,
  emptyIcon: a,
  error: l,
  errorIcon: c,
  inner: b,
  item: d
}), p = {
  xs: o({
    error: {
      fontSize: "xs"
    },
    errorIcon: {
      boxSize: e(16)
    },
    emptyIcon: {
      boxSize: e(16)
    },
    base: {
      maxWidth: e(48)
    }
  }),
  sm: o({
    error: {
      fontSize: "sm"
    },
    errorIcon: {
      boxSize: e(24)
    },
    emptyIcon: {
      boxSize: e(24)
    },
    base: {
      maxWidth: e(68)
    }
  }),
  md: o({
    error: {
      fontSize: "md"
    },
    errorIcon: {
      boxSize: e(32)
    },
    emptyIcon: {
      boxSize: e(32)
    },
    base: {
      maxWidth: e(96)
    }
  }),
  lg: o({
    error: {
      fontSize: "lg"
    },
    errorIcon: {
      boxSize: e(48)
    },
    emptyIcon: {
      boxSize: e(48)
    },
    base: {
      maxWidth: e(128)
    }
  }),
  xl: o({
    error: {
      fontSize: "xl"
    },
    errorIcon: {
      boxSize: e(64)
    },
    emptyIcon: {
      boxSize: e(64)
    },
    base: {
      maxWidth: e(196)
    }
  }),
  "2xl": o({
    error: {
      fontSize: "2xl"
    },
    errorIcon: {
      boxSize: e(84)
    },
    emptyIcon: {
      boxSize: e(84)
    },
    base: {
      maxWidth: e(262)
    }
  }),
  full: o({
    error: {
      fontSize: "3xl"
    },
    errorIcon: {
      boxSize: e(112)
    },
    emptyIcon: {
      boxSize: e(112)
    },
    base: {
      width: "100%",
      height: "100%"
    }
  })
}, S = t({
  baseStyle: m,
  sizes: p,
  defaultProps: {
    size: "md"
  }
});
export {
  S as AvatarList
};
//# sourceMappingURL=AvatarList.es.js.map
